import t from "react";
var _e = function e(t, o) {
  return (_e = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (t, e) {
    t.__proto__ = e;
  } || function (t, e) {
    for (var o in e) e.hasOwnProperty(o) && (t[o] = e[o]);
  })(t, o);
};
var _o = function o() {
    return (_o = Object.assign || function (t) {
      for (var e, o = 1, n = arguments.length; o < n; o++) for (var r in e = arguments[o]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      return t;
    }).apply(this, arguments);
  },
  n = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {},
  r = "Expected a function",
  i = NaN,
  f = "[object Symbol]",
  a = /^\s+|\s+$/g,
  u = /^[-+]0x[0-9a-f]+$/i,
  c = /^0b[01]+$/i,
  s = /^0o[0-7]+$/i,
  l = parseInt,
  p = "object" == typeof n && n && n.Object === Object && n,
  d = "object" == typeof self && self && self.Object === Object && self,
  m = p || d || Function("return this")(),
  h = Object.prototype.toString,
  v = Math.max,
  y = Math.min,
  b = function b() {
    return m.Date.now();
  };
function w(t, e, o) {
  var n,
    i,
    f,
    a,
    u,
    c,
    s = 0,
    l = !1,
    p = !1,
    d = !0;
  if ("function" != typeof t) throw new TypeError(r);
  function m(e) {
    var o = n,
      r = i;
    return n = i = void 0, s = e, a = t.apply(r, o);
  }
  function h(t) {
    var o = t - c;
    return void 0 === c || o >= e || o < 0 || p && t - s >= f;
  }
  function w() {
    var t = b();
    if (h(t)) return S(t);
    u = setTimeout(w, function (t) {
      var o = e - (t - c);
      return p ? y(o, f - (t - s)) : o;
    }(t));
  }
  function S(t) {
    return u = void 0, d && n ? m(t) : (n = i = void 0, a);
  }
  function j() {
    var t = b(),
      o = h(t);
    if (n = arguments, i = this, c = t, o) {
      if (void 0 === u) return function (t) {
        return s = t, u = setTimeout(w, e), l ? m(t) : a;
      }(c);
      if (p) return u = setTimeout(w, e), m(c);
    }
    return void 0 === u && (u = setTimeout(w, e)), a;
  }
  return e = O(e) || 0, g(o) && (l = !!o.leading, f = (p = "maxWait" in o) ? v(O(o.maxWait) || 0, e) : f, d = "trailing" in o ? !!o.trailing : d), j.cancel = function () {
    void 0 !== u && clearTimeout(u), s = 0, n = c = i = u = void 0;
  }, j.flush = function () {
    return void 0 === u ? a : S(b());
  }, j;
}
function g(t) {
  var e = typeof t;
  return !!t && ("object" == e || "function" == e);
}
function O(t) {
  if ("number" == typeof t) return t;
  if (function (t) {
    return "symbol" == typeof t || function (t) {
      return !!t && "object" == typeof t;
    }(t) && h.call(t) == f;
  }(t)) return i;
  if (g(t)) {
    var e = "function" == typeof t.valueOf ? t.valueOf() : t;
    t = g(e) ? e + "" : e;
  }
  if ("string" != typeof t) return 0 === t ? t : +t;
  t = t.replace(a, "");
  var o = c.test(t);
  return o || s.test(t) ? l(t.slice(2), o ? 2 : 8) : u.test(t) ? i : +t;
}
var S = function S(t, e, o) {
  var n = !0,
    i = !0;
  if ("function" != typeof t) throw new TypeError(r);
  return g(o) && (n = "leading" in o ? !!o.leading : n, i = "trailing" in o ? !!o.trailing : i), w(t, e, {
    leading: n,
    maxWait: e,
    trailing: i
  });
};
var j = 44,
  T = function (n) {
    function r(e) {
      var o = n.call(this, e) || this;
      return o.state = {
        bottom: o.props.offset || 0
      }, o.isSafariMobile = function () {
        if ("undefined" == typeof window || void 0 === window.navigator) return !1;
        var t = window.navigator.userAgent;
        return /iP(ad|od|hone)/i.test(t) && /WebKit/i.test(t) && !/(CriOS|FxiOS|OPiOS|mercury)/i.test(t);
      }(), o.anchorRef = t.createRef(), o.computeOffsetBottom = function () {
        if (o.anchorRef.current) {
          var t = o.anchorRef.current.getBoundingClientRect().bottom,
            e = o.props.offset,
            n = void 0 === e ? 0 : e;
          Math.floor(Number(t)) > window.innerHeight ? o.setState({
            bottom: n + j
          }) : o.setState({
            bottom: n
          });
        }
      }, o.handleScroll = S(o.computeOffsetBottom, 200), o;
    }
    return function (t, o) {
      function n() {
        this.constructor = t;
      }
      _e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
    }(r, n), r.prototype.componentDidMount = function () {
      this.isSafariMobile && (window.addEventListener("scroll", this.handleScroll), this.deferredComputeOffsetBottom = setTimeout(this.computeOffsetBottom));
    }, r.prototype.componentWillUnmount = function () {
      this.isSafariMobile && (this.handleScroll.cancel(), window.removeEventListener("scroll", this.handleScroll), window.clearTimeout(this.deferredComputeOffsetBottom));
    }, r.prototype.render = function () {
      var e = this.state.bottom,
        n = this.props,
        r = n.children,
        i = n.offset,
        f = t.cloneElement(r, {
          style: _o({}, r.props.style, {
            bottom: e,
            position: "fixed"
          })
        });
      return t.createElement(t.Fragment, null, f, this.isSafariMobile && t.createElement("div", {
        ref: this.anchorRef,
        style: {
          position: "fixed",
          bottom: i
        }
      }));
    }, r;
  }(t.PureComponent);
export { T as FixedBottom };